import { render } from "./KeyPad.vue?vue&type=template&id=4d4afbb8&scoped=true&bindings={\"answer\":\"props\",\"userInput\":\"data\",\"inputWasCorrect\":\"data\",\"audioPosition\":\"options\",\"exitButton\":\"options\",\"deleteKeyHandle\":\"options\",\"enterKeyHandle\":\"options\",\"numberKeyHandle\":\"options\"}"
import script from "./KeyPad.vue?vue&type=script&lang=js"
export * from "./KeyPad.vue?vue&type=script&lang=js"

import "./KeyPad.vue?vue&type=style&index=0&id=4d4afbb8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4d4afbb8"

export default script